<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" label-width="70px">
          <el-form-item label="平台单号">
            <el-input v-model="searchForm.platformOrderNumber" clearable size="mini"> </el-input>
          </el-form-item>
          <el-form-item label="国补类型" prop="type">
            <el-select v-model="searchForm.type" filterable multiple clearable collapse-tags @change="typeChange">
              <el-option v-show="!all" label="全部" value=""></el-option>
              <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in typeList" :label="item.stateSubsidiesName" :value="item.stateSubsidiesCode" :key="item.stateSubsidiesCode" />
            </el-select>
          </el-form-item>
          <el-form-item label="适用店铺" prop="store">
            <el-select v-model="searchForm.store" filterable multiple clearable collapse-tags @change="storeChange">
              <el-option v-show="!all2" label="全部" value=""></el-option>
              <el-option v-show="all2" label="取消所有" value="cancleAll"></el-option>
              <el-option v-for="item in storeList" :label="item.name" :value="item.code" :key="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="付款日期">
            <form-date-range :form="searchForm" startKey="dts" :usingTime="false" endKey="dte" valueFormat="yyyy-MM-dd"> </form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="onReset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" class="red-btn" size="mini" @click="delRow(null)">删除</el-button>
        <el-button type="primary" size="mini" @click="importExcel">导入</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        border
        stripe
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        :data="tableData.list"
        :height="maxTableHeight"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        :row-key="(row) => row.id"
      >
        <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column>
        <el-table-column label="平台单号" prop="platformOrderNumber" min-width="180"> </el-table-column>
        <el-table-column label="国补类型" prop="stateSubsidiesName" min-width="150"> </el-table-column>
        <el-table-column label="店铺" prop="storeName" min-width="180"> </el-table-column>
        <el-table-column label="订单付款时间" prop="payTime" min-width="160"> </el-table-column>
        <el-table-column label="导入人" prop="userName" min-width="100"> </el-table-column>
        <el-table-column label="导入时间" prop="dt" min-width="160"> </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" class="red-text-btn" @click="delRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'NationalSubsidiesType',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      loading2: false,
      searchForm: {
        dts: '',
        dte: '',
        type: [],
        store: [],
      },
      tableData: {
        list: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportData: {},
      columnsData: [],
      isShowImport: false,
      all: false,
      all2: false,
      rowData: {},
      typeList: [],
      storeList: [],
      selectSpus: [],
    };
  },
  mounted() {
    this.init();
    this.getTypeOptions();
    this.getStoreOptions();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection()
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.searchForm = {
        dts: '',
        dte: '',
        type: [],
        store: [],
      };
      this.onSearch();
    },
    init() {
      this.loading = true;
      let { type, store } = this.searchForm;
      let data = {
        filterData: {
          ...this.searchForm,
          stateSubsidiesCode: type.length ? type.join(',') : '',
          storeId: store.length ? store.join(',') : '',
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.searchFormData = data.filterData
      this.$q.configurationCenter
        .orderPageQuery({ data: data })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    typeChange(val) {
      this.all = this.typeList.length == val.length;
      if (val.includes("")) {
        this.searchForm.type = this.typeList.map(v=>v.stateSubsidiesCode);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.type = [];
        this.all = false;
      }
    },
    storeChange(val) {
      this.all2 = this.storeList.length == val.length;
      if (val.includes("")) {
        this.searchForm.store = this.storeList.map(v=>v.code);
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.store = [];
        this.all2 = false;
      }
    },
    handleSelectionChange(val) {
      this.selectSpus = val;
    },
    async delRow(row) {
      if(!row && !this.selectSpus.length) {
        return this.$message.error('请选择要删除的数据');
      }
      let data = row ? [row.id] : this.selectSpus.map((v) => v.id);
      let status = await this.$confirm('是否确认删除？', '提示', {
        type: 'warning',
      });
      if (status !== 'confirm') return;
      this.$q.configurationCenter.deleteOrder({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          this.onSearch();
        }
      });
    },
    getTypeOptions() {
      this.$q.configurationCenter.queryStateSubsidiesType().then((res) => {
        this.typeList = res.data;
      });
    },
    getStoreOptions() {
      this.$q.configurationCenter.queryStoreList().then((res) => {
        this.storeList = res.data;
      });
    },
    //导入
    importExcel() {
      this.openSubPage({
        path: '/nationalSubsidyOrderImport',
        query: {
          fileName: '国补订单文件导入.xlsx',
          appCode: 'ec-pc-new',
          reportName: 'stateOrderImport',
        },
      })
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData,
        },
        reportName: 'state_order',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
.footerBox
  text-align right
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

>>> .form-number-input .el-input-number {
    width: 105px !important;
}
>>> .form-number-input .el-input-number .el-input {
    width: 105px !important;
}
>>> .el-select__tags-text {
  display: inline-block;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
